// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9b80256b","453":"c35834d5","796":"dd70eac2","952":"b989ee2f"}[chunkId] + ".chunk.js";
};